<template>
  <b-modal id="modal-fixed-popup" size="sm" centered hide-header body-class="modal-popup">
    <div class="d-block text-center">
      <Icon name="grStars" width="36" class="mb-2"/>
      <h1 class="modal-title" v-if="title">{{ title }}</h1>
      <div class="modal-popup__text scroll mt-3">
        <div v-html="text"></div>
      </div>
      <div class="modal-popup__blur"></div>
    </div>
    <template #modal-footer>
      <div class="d-block w-100">
        <b-button variant="primary" block @click="hide">
          {{ $t('modal_popup.btn_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "FixedPopup",
  props: {
    picaServiceId: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters('checkinDetail', ['isPopupViewed']),
  },
  mounted() {
    if (this.active && !this.isPopupViewed('fixed', this.picaServiceId)) {
      this.$bvModal.show("modal-fixed-popup")
      this.setPopupViewed({type: 'fixed', picaServiceId: this.picaServiceId})
    }
  },
  methods: {
    ...mapActions('checkinDetail', ['setPopupViewed']),
    hide() {
      this.$bvModal.hide("modal-fixed-popup")
    },
  },
}
</script>
